import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, map, shareReplay, switchMap } from 'rxjs/operators';
import { StaticFileUrlService } from 'Angular/services/static-file-url.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/platform-browser";
import * as i3 from "Angular/services/static-file-url.service";
/**
 * SVG Sprite Service
 *
 * Handles loading and inlining of SVG sprite files for improved performance.
 * The sprite is loaded once and cached, then can be referenced locally using #icon-name.
 */
export class SvgSpriteService {
    constructor(http, sanitizer, staticFileUrlService) {
        this.http = http;
        this.sanitizer = sanitizer;
        this.staticFileUrlService = staticFileUrlService;
        this.spriteLoaded$ = new BehaviorSubject(false);
        this.spriteElementId = 'yc-svg-sprite-container';
        this.inlineSpriteInitialized = false;
        // Load sprite on service initialization
        this.spriteContent$ = this.loadSprite();
    }
    /**
     * Load the SVG sprite file and prepare it for inlining
     */
    loadSprite() {
        return this.staticFileUrlService.getRelativeUrl('images/redesign/icons.svg').pipe(switchMap((url) => {
            // Remove any hash fragment from the URL
            const cleanUrl = url.split('#')[0];
            return this.http.get(cleanUrl, { responseType: 'text' });
        }), map((svgContent) => {
            // Sanitize the SVG content
            return this.sanitizer.bypassSecurityTrustHtml(svgContent);
        }), catchError(() => {
            // Failed to load SVG sprite - fall back to null
            return of(null);
        }), shareReplay(1) // Cache the result
        );
    }
    /**
     * Inject the SVG sprite into the DOM
     * This method is idempotent - multiple calls are safe
     */
    inlineSprite() {
        if (this.inlineSpriteInitialized) {
            return;
        }
        this.inlineSpriteInitialized = true;
        const existingContainer = document.getElementById(this.spriteElementId);
        if (existingContainer?.querySelector('svg')) {
            this.spriteLoaded$.next(true);
            return;
        }
        this.spriteContent$.subscribe((safeContent) => {
            if (safeContent) {
                const content = this.sanitizer.sanitize(1, safeContent);
                if (content) {
                    // Use existing container or create new one
                    let container = document.getElementById(this.spriteElementId);
                    if (!container) {
                        container = document.createElement('div');
                        container.id = this.spriteElementId;
                        container.style.display = 'none';
                        container.setAttribute('aria-hidden', 'true');
                        document.body.appendChild(container);
                    }
                    container.innerHTML = content;
                    this.spriteLoaded$.next(true);
                }
            }
        });
    }
    /**
     * Check if the sprite has been loaded and inlined
     */
    isSpriteLoaded() {
        return this.spriteLoaded$.asObservable();
    }
    /**
     * Get the inline reference for an icon
     * Returns just the hash reference without the full URL
     */
    getInlineReference(iconName) {
        return `#${iconName}`;
    }
}
SvgSpriteService.ɵfac = function SvgSpriteService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SvgSpriteService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.DomSanitizer), i0.ɵɵinject(i3.StaticFileUrlService)); };
SvgSpriteService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SvgSpriteService, factory: SvgSpriteService.ɵfac, providedIn: 'root' });
